import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGrid from "./ImageGrid";
import Donation from "../Home/Donation";
import p1 from "../../assets/images/1.jpg";
import p2 from "../../assets/images/2.jpg";
import p3 from "../../assets/images/3.jpg";
import p4 from "../../assets/images/4.jpg";
import p5 from "../../assets/images/5.jpg";
import p6 from "../../assets/images/6.jpg";
import { Fade } from "react-awesome-reveal";
import axios from "axios";
import { FaSpinner } from "react-icons/fa6";

const staticImages = [
  { original: p1, thumbnail: p1 },
  { original: p2, thumbnail: p2 },
  { original: p3, thumbnail: p3 },
  { original: p4, thumbnail: p4 },
  { original: p5, thumbnail: p5 },
  { original: p6, thumbnail: p6 },
];

const MosqueImg = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await axios.get(
          "https://mosque-backend-yfae.vercel.app/allEvents",
        );
        setEvents(response.data);
      } catch (error) {
        console.error("Error fetching event data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEventData();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-64 flex flex-col items-center justify-center gap-3 text-stone-400">
        <FaSpinner className="w-8 h-8 animate-spin text-emerald-800" />
        <span className="text-sm font-medium tracking-wide">
          Syncing Media Assets...
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="py-12 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-8">
            <span className="text-xs font-bold uppercase tracking-widest text-emerald-800">
              Visual Tour
            </span>
            <h2 className="text-3xl font-extrabold text-green-950 mt-1">
              Mosque Architecture
            </h2>
          </div>
        </Fade>

        {/* Styled Image Gallery Slider Container wrapper */}
        <div className="bg-white p-2 sm:p-4 rounded-2xl border border-stone-100 shadow-xl overflow-hidden custom-gallery">
          <ImageGallery
            showNav={true}
            autoPlay={true}
            slideInterval={4000}
            showPlayButton={false}
            items={staticImages}
            showBullets={true}
            renderItem={(item) => (
              <div className="relative aspect-[16/9] sm:h-[480px] w-full overflow-hidden rounded-xl">
                <img
                  src={item.original}
                  alt="Mosque Interior"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            renderThumbInner={(item) => (
              <div className="h-14 sm:h-16 w-full overflow-hidden rounded-lg">
                <img
                  src={item.thumbnail}
                  alt="Thumbnail Preview"
                  className="h-full w-full object-cover hover:scale-105 transition-transform"
                />
              </div>
            )}
          />
        </div>
      </div>

      <Donation />

      {/* Dinamycally Map Fetched Events */}
      <div className="space-y-4">
        {events.map((event) => (
          <ImageGrid
            key={event._id}
            title={event.title}
            images={event.images}
          />
        ))}
      </div>
    </>
  );
};

export default MosqueImg;
